import React, {useEffect, useState} from "react";
import ListPagination from "./ListPagination";
import {Col, Row} from "react-bootstrap";
import Loader from "./Loader";

const ListTable = ({ data, header, listItem, searchFields = ['name', 'details'], showSearch = true }) => {
  const [tableData, setTableData] = useState([])
  const [page, setPage] = useState(1)

  useEffect(() => {
    if (data)
      setTableData(data)
  }, [data]);

  if (!data) return <Loader />

  const itemsPerPage = 15
  const offset = (page - 1) * itemsPerPage

  const doSearch = (e) => {
    const queryString = e.target.value

    const filtered = data.filter(item => {
      const found = searchFields.map(field => {
        try {
          let value = item;
          field.split('.').forEach(key => value = value[key])
          value = String(value)
            .replaceAll('ă', 'a')
            .replaceAll('â', 'a')
            .replaceAll('î', 'i')
            .replaceAll('ș', 's')
            .replaceAll('ț', 't')
          if (value.search(new RegExp(queryString, "i")) >= 0)
            return true
        } catch (e) {
          console.error('error ', e)
        }
        return false
      })
      return found.includes(true)
    })
    setPage(1)
    setTableData(filtered)
  }

  const totalPages = Math.ceil(tableData.length / itemsPerPage)
  // console.log(totalPages, page, offset)

  return (
    <>
      {showSearch &&
        <Row className="mb-4">
          <Col>
            <input type='text' className='form-control' onKeyUp={doSearch} placeholder='Cauta' />
          </Col>
        </Row>
      }

      <div className="bg-white p-2 rounded shadow">
        <table className="table table-striped">
          <thead>
          {header}
          </thead>
          <tbody>
          {tableData.slice(offset, offset + itemsPerPage).map((item, index) => {
            return listItem(item, index)
          })}
          </tbody>
          {totalPages > 1 &&
            <tfoot>
            <tr>
              <td colSpan={100} className='text-end'>
                <ListPagination {...{ page, totalPages, setPage }}></ListPagination>
              </td>
            </tr>
            </tfoot>
          }
        </table>
      </div>
    </>
  )
};

export default ListTable;
